export default "__VITE_ASSET__ad3578aa__"